import { Component, OnInit } from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { Router } from '@angular/router'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'

@Component({
  standalone: false,
  selector: 'app-quote-model',
  templateUrl: './quote-model.component.html',
  styleUrls: ['./quote-model.component.scss'],
})
export class QuoteModelComponent implements OnInit {
  constructor(
    private launchDialogService: LaunchDialogService,
    private router: Router
  ) {}

  ngOnInit(): void {}
  dismissModal(reason?: any): void {
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.QUOTE_MODAL,
      reason: reason,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }

  navigateToCart(reason?: any): void {
    this.router.navigate(['/quote/cart'])
    this.dismissModal(reason)
  }
}
